import { Navigate, Route, Routes } from "react-router-dom";

import { EmployeeList } from "./EmployeeList/EmployeeList";
import { EmployeeCreate } from "./EmployeeCreate/EmployeeCreate";
import { EmployeeView } from "./EmployeeView";
import { PrivateRoute } from "../../keycloak";
import { UserRoles } from "../../constants/userRoles";

export const Employee = () => {
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute
            roles={{
              dcs_client: [UserRoles.USER_CREATE],
            }}
          />
        }
      >
        <Route path={`create`} element={<EmployeeCreate />} />
      </Route>
      <Route
        element={
          <PrivateRoute
            roles={{
              dcs_client: [UserRoles.USER_VIEW],
            }}
          />
        }
      >
        <Route path={`:employeeId/*`} element={<EmployeeView />} />
        <Route index path="/" element={<EmployeeList />} />
        <Route path="*" element={<Navigate to="/not-found" replace />} />
      </Route>
    </Routes>
  );
};
